new Swiper('.main-page-hero-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    autoplay: {
        delay: 5000,
    },

    pagination: {
        el: '.hero-pagination',
        clickable: true
    },
    on: {
        slideChange: function () {
            const swiper = this;
            const paginationEl = document.querySelector('.main-page-hero-swiper .hero-pagination');
            const lastSlideIndex = swiper.slides.length - 1; 
            // Check if it's the last slide
            if (swiper.realIndex === lastSlideIndex) {
                paginationEl.classList.add('last-slide');
            } else {
                paginationEl.classList.remove('last-slide');
            }
        }
    }
});
new Swiper('.hero-text-reviews-bottom-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
    },
    speed: 1000,
});